import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { MainNavToggleService } from './services/main-nav-toggle.service';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { NgClass } from '@angular/common';
import { INavbarData } from './models/nav.model';
import { MenuItem } from './models/menu.model';
import { MenuService } from './services/menu.service';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  standalone: true,
  styleUrls: ['./main-nav.component.scss'],
  imports: [MenuItemComponent, NgClass],
  providers: [MenuService]
})
export class MainNavComponent implements OnDestroy, OnInit {
  navData: INavbarData[] = [];
  isExpanded = false;
  isLoading = false;
  isDrawerExpanded = false;
  @ViewChild('myMainNav') myMainNav?: ElementRef;
  private toggleSubscription: Subscription = new Subscription();

  constructor(
    private mainNavToggleService: MainNavToggleService,
    private menuService: MenuService
  ) {}

  ngOnInit() {
    this.initMenuItems();
    this.mainNavToggleService.isOpen$.subscribe((isOpen) => {
      if (this.myMainNav) {
        this.myMainNav.nativeElement.style.width = isOpen ? '250px' : '0';
        this.isExpanded = isOpen;
      }
    });
  }

  ngOnDestroy() {
    this.toggleSubscription?.unsubscribe();
  }

  initMenuItems() {
    this.menuService.getMenuItems().subscribe({
      next: (items: MenuItem[]) => {
        if (!items) {
          return;
        }
        this.isLoading = true;
        this.navData = this.menuService.convertMenuItemsToNavData(items);
      },
      error: (error: any) => {
        console.error('Ошибка при загрузке элементов меню:', error);
      }
    });
  }
}
